module.exports = __webpack_public_path__ + "static/img/78118C_3_C_20230802_fit.aac6439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78118C_3_C_20230802_fit.png
// module id = h6UM
// module chunks = 0